import { O as OrthographicCamera } from './utils-f2d0253a.js';
import { c as createCommonjsModule } from './_commonjsHelpers-1d681858.js';
import { M as MINUTE_IN_MS, D as DAY_IN_MS, S as SECOND_IN_MS, Y as YEAR_IN_MS } from './time-051aeed0.js';
import { v as v4_1 } from './v4-9366210a.js';
var colorName = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
};
var isArrayish = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') {
        return false;
    }
    return obj instanceof Array || Array.isArray(obj) ||
        (obj.length >= 0 && (obj.splice instanceof Function ||
            (Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};
var simpleSwizzle = createCommonjsModule(function (module) {
    var concat = Array.prototype.concat;
    var slice = Array.prototype.slice;
    var swizzle = module.exports = function swizzle(args) {
        var results = [];
        for (var i = 0, len = args.length; i < len; i++) {
            var arg = args[i];
            if (isArrayish(arg)) {
                // http://jsperf.com/javascript-array-concat-vs-push/98
                results = concat.call(results, slice.call(arg));
            }
            else {
                results.push(arg);
            }
        }
        return results;
    };
    swizzle.wrap = function (fn) {
        return function () {
            return fn(swizzle(arguments));
        };
    };
});
var colorString = createCommonjsModule(function (module) {
    /* MIT license */
    var hasOwnProperty = Object.hasOwnProperty;
    var reverseNames = Object.create(null);
    // create a list of reverse color names
    for (var name in colorName) {
        if (hasOwnProperty.call(colorName, name)) {
            reverseNames[colorName[name]] = name;
        }
    }
    var cs = module.exports = {
        to: {},
        get: {}
    };
    cs.get = function (string) {
        var prefix = string.substring(0, 3).toLowerCase();
        var val;
        var model;
        switch (prefix) {
            case 'hsl':
                val = cs.get.hsl(string);
                model = 'hsl';
                break;
            case 'hwb':
                val = cs.get.hwb(string);
                model = 'hwb';
                break;
            default:
                val = cs.get.rgb(string);
                model = 'rgb';
                break;
        }
        if (!val) {
            return null;
        }
        return { model: model, value: val };
    };
    cs.get.rgb = function (string) {
        if (!string) {
            return null;
        }
        var abbr = /^#([a-f0-9]{3,4})$/i;
        var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
        var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
        var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
        var keyword = /^(\w+)$/;
        var rgb = [0, 0, 0, 1];
        var match;
        var i;
        var hexAlpha;
        if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for (i = 0; i < 3; i++) {
                // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
                var i2 = i * 2;
                rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
            }
            if (hexAlpha) {
                rgb[3] = parseInt(hexAlpha, 16) / 255;
            }
        }
        else if (match = string.match(abbr)) {
            match = match[1];
            hexAlpha = match[3];
            for (i = 0; i < 3; i++) {
                rgb[i] = parseInt(match[i] + match[i], 16);
            }
            if (hexAlpha) {
                rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
            }
        }
        else if (match = string.match(rgba)) {
            for (i = 0; i < 3; i++) {
                rgb[i] = parseInt(match[i + 1], 0);
            }
            if (match[4]) {
                if (match[5]) {
                    rgb[3] = parseFloat(match[4]) * 0.01;
                }
                else {
                    rgb[3] = parseFloat(match[4]);
                }
            }
        }
        else if (match = string.match(per)) {
            for (i = 0; i < 3; i++) {
                rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            }
            if (match[4]) {
                if (match[5]) {
                    rgb[3] = parseFloat(match[4]) * 0.01;
                }
                else {
                    rgb[3] = parseFloat(match[4]);
                }
            }
        }
        else if (match = string.match(keyword)) {
            if (match[1] === 'transparent') {
                return [0, 0, 0, 0];
            }
            if (!hasOwnProperty.call(colorName, match[1])) {
                return null;
            }
            rgb = colorName[match[1]];
            rgb[3] = 1;
            return rgb;
        }
        else {
            return null;
        }
        for (i = 0; i < 3; i++) {
            rgb[i] = clamp(rgb[i], 0, 255);
        }
        rgb[3] = clamp(rgb[3], 0, 1);
        return rgb;
    };
    cs.get.hsl = function (string) {
        if (!string) {
            return null;
        }
        var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = ((parseFloat(match[1]) % 360) + 360) % 360;
            var s = clamp(parseFloat(match[2]), 0, 100);
            var l = clamp(parseFloat(match[3]), 0, 100);
            var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [h, s, l, a];
        }
        return null;
    };
    cs.get.hwb = function (string) {
        if (!string) {
            return null;
        }
        var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = ((parseFloat(match[1]) % 360) + 360) % 360;
            var w = clamp(parseFloat(match[2]), 0, 100);
            var b = clamp(parseFloat(match[3]), 0, 100);
            var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [h, w, b, a];
        }
        return null;
    };
    cs.to.hex = function () {
        var rgba = simpleSwizzle(arguments);
        return ('#' +
            hexDouble(rgba[0]) +
            hexDouble(rgba[1]) +
            hexDouble(rgba[2]) +
            (rgba[3] < 1
                ? (hexDouble(Math.round(rgba[3] * 255)))
                : ''));
    };
    cs.to.rgb = function () {
        var rgba = simpleSwizzle(arguments);
        return rgba.length < 4 || rgba[3] === 1
            ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
            : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
    };
    cs.to.rgb.percent = function () {
        var rgba = simpleSwizzle(arguments);
        var r = Math.round(rgba[0] / 255 * 100);
        var g = Math.round(rgba[1] / 255 * 100);
        var b = Math.round(rgba[2] / 255 * 100);
        return rgba.length < 4 || rgba[3] === 1
            ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
            : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
    };
    cs.to.hsl = function () {
        var hsla = simpleSwizzle(arguments);
        return hsla.length < 4 || hsla[3] === 1
            ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
            : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
    };
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    cs.to.hwb = function () {
        var hwba = simpleSwizzle(arguments);
        var a = '';
        if (hwba.length >= 4 && hwba[3] !== 1) {
            a = ', ' + hwba[3];
        }
        return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
    };
    cs.to.keyword = function (rgb) {
        return reverseNames[rgb.slice(0, 3)];
    };
    // helpers
    function clamp(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = Math.round(num).toString(16).toUpperCase();
        return (str.length < 2) ? '0' + str : str;
    }
});
var getCSSColorByString = function (color) {
    var cssColor = colorString.get(color);
    if (cssColor == null) {
        // eslint-disable-next-line no-console
        console.error("provided an invalid color string, '" + color + "'");
    }
    return cssColor == null ? [0, 0, 0] : cssColor.value;
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Create Vertices
 *
 * Converts the `DataStream`s model to 2 dimensional vertices in a format consumable by WebGL.
 * Format is as follows,
 * `[[point_1_x, point_1_y, point_1_color_red, point_1_color_blue, point_1_color_green], ...]`
 */
var vertices = function (stream) {
    var _b = getCSSColorByString(stream.color || 'black'), r = _b[0], g = _b[1], b = _b[2];
    return stream.data.map(function (p) { return [p.x, p.y, r, g, b]; });
};
// The max and minimum z value an entity may have and still be present.
// Currently we don't utilize depth so these clipping panes will have no effect on the data.
var NEAR = 0.1;
var FAR = 1000;
/**
 * Dispose of scene
 *
 * Disposes of the scene and recursively removes and disposes of all meshes within the scene
 */
var dispose = function (scene) {
    // https://threejs.org/docs/#manual/en/introduction/How-to-dispose-of-objects
    scene.children.forEach(function (obj) {
        try {
            var mesh = obj;
            // Remove each mesh, and it's associated shader and geometry
            mesh.geometry.dispose();
            var materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
            materials.forEach(function (material) {
                material.dispose();
            });
        }
        catch (_a) {
            // NOTE: This error should never occur
            throw new Error("\n        scene currently does not support objects of type " + obj.constructor.name + "\n        and does not know how to dispose of it.\n      ");
        }
    });
};
/**
 * Construct Chart Scene
 *
 * Takes a threejs scene and some chart configuration, and constructs the corresponding chart scene.
 */
var constructChartScene = function (_b) {
    var scene = _b.scene, container = _b.container, viewport = _b.viewport, toClipSpace = _b.toClipSpace, onUpdate = _b.onUpdate;
    // Create a camera pointed at our viewport - this determines which part of the mesh we see.
    var camera = new OrthographicCamera(toClipSpace(viewport.start.getTime()), toClipSpace(viewport.end.getTime()), viewport.yMax, viewport.yMin, NEAR, FAR);
    // Orthographic camera so the z position doesn't actually matter. i.e. depth is ignored.
    camera.position.z = 500;
    return {
        toClipSpace: toClipSpace,
        scene: scene,
        container: container,
        id: v4_1(),
        camera: camera,
        dispose: function () { return dispose(scene); },
        /**
         * A Unique identifier for the grouping of viewports which this chart syncs with.
         *
         * Whenever any of the viewports are altered within a viewport group, all of the charts
         * within the view port group will have their viewport start and end dates synced.
         *
         * A lack of a viewportGroup means that the chart is not synced with any of charts.
         */
        viewportGroup: viewport.group,
        updateViewPort: function (_a) {
            var start = _a.start, end = _a.end, rest = __rest(_a, ["start", "end"]);
            /**
             * Update threejs cameras position.
             * This will cause the shaders to have an updated uniform, utilized
             * to project the data visualizations to the correct position.
             */
            // eslint-disable-next-line no-param-reassign
            camera.left = toClipSpace(start.getTime());
            // eslint-disable-next-line no-param-reassign
            camera.right = toClipSpace(end.getTime());
            camera.updateProjectionMatrix();
            /**
             * Call optional lifecycle method. This lifecycle method can be used
             * for non-webGL based features, i.e. thresholds, axis, etc.
             */
            if (onUpdate) {
                onUpdate(Object.assign({ start: start, end: end }, rest));
            }
        },
    };
};
/**
 * Get Number of Data Points
 *
 * Total data points across all data streams
 */
var numDataPoints = function (dataStreams) { return dataStreams.map(function (stream) { return stream.data.length; }).reduce(function (total, num) { return total + num; }, 0); };
/**
 * Clip Space Conversion Utilities
 *
 * Our 'model' space utilizes milliseconds to represent time. This level of granularity is important
 * since we do wish to be able to visually represent the time differences at that level of detail.
 *
 * However, there are 3.15e+10 milliseconds in a year. This is problematic because it means that we cannot represent
 * a years worth of data at the millisecond level granularity utilizing 32 bit floats.
 *
 * double precision is not supported by webGL - there are ways to represent double precision, however these
 * are unnecessarily complicated, double our memory foot print, and actually not necessary.
 *
 * Interesting article on doubles: http://blog.hvidtfeldts.net/index.php/2012/07/double-precision-in-opengl-and-webgl/
 *
 * ## Why Not Necessary To Utilize Doubles?
 *
 * While we need millisecond level precision, we do not need to be able to visually differentiate between milliseconds
 * while looking at even a weeks worth of data. Even if we did, you would not be able to discern a difference
 * due to resolution limitations. Even if you had a hypothetically perfect monitor that could discern a planks-constant
 * level of resolution, the eye would not be able to tell without advanced optical instrumentation!
 *
 * ## Solution
 *
 * We do two things to mitigate - based on the time duration of a given viewport, we will scale down the numbers and
 * truncate the decimals such that the distance from the end to the start of the viewport is representable by a floating point.
 *
 * However, this leaves one more problem - imagine after scaling our viewport in our clip space, we could have
 * our start be 1.20001e+8 to 1.20002e+8, we would have a distance of 1000, which is representable by a 32 bit float, however
 * each number within that range is still not representable by a 32 bit float. To account for this, we also must translate our clip
 * space by what we refer to as an anchor. Suppose we utilize 1.2*10^8 as an anchor, our clip space time range is now 1000 to 2000.
 * Success! We can now represent our time within webgl by a 32 bit float.
 *
 * ## Caveats
 *
 * Since the viewport is dynamic, we have to make sure that as our viewport moves around, we update our `clip space conversion`.
 * Translating, scaling-in, and scaling-out can all cause our `clip space conversion` to start outputting numbers which are not representable by 32 bit floats.
 * To solve this, we also must make sure we watch for viewport changes and adjust our conversion accordingly.
 */
/**
 * Granularity
 *
 * given a duration, return the granularity in milliseconds.
 * By granularity we mean the minimal time difference which is visually differentiated.
 */
var granularity = function (durationMS) {
    if (durationMS < 10 * MINUTE_IN_MS) {
        // single millisecond
        return 1;
    }
    if (durationMS < DAY_IN_MS) {
        return SECOND_IN_MS / 10;
    }
    if (durationMS < DAY_IN_MS * 7) {
        return SECOND_IN_MS;
    }
    if (durationMS < YEAR_IN_MS) {
        return MINUTE_IN_MS;
    }
    if (durationMS < 30 * YEAR_IN_MS) {
        return 30 * MINUTE_IN_MS;
    }
    return DAY_IN_MS;
};
/**
 * Clip Space Conversion
 *
 * Converts something from model space (millisecond representation of time) into our clip space.
 * The goal is to be able to represent the time from `start` to `end` with floating point precision (7 significant digits).
 */
var clipSpaceConversion = function (viewport) {
    var durationMS = viewport.end.getTime() - viewport.start.getTime();
    var anchorMS = viewport.start.getTime() - durationMS * 0.25;
    var granularityMS = granularity(durationMS);
    return function (t) { return Math.floor((t - anchorMS) / granularityMS); };
};
var FLOAT_SIG_FIGS = 7;
var isDateOutOfBounds = function (date, toClipSpace) { return Math.abs(toClipSpace(date.getTime())) >= Math.pow(10, FLOAT_SIG_FIGS); };
// Minimum amount of distinct positions our clip spaces needs to represent.
var MIN_GRANULARITY = 3000;
/**
 * Needs New Clip Space
 *
 * There are two conditions which can occur which will require a new clip space.
 *
 * 1. The viewport when mapped to the clip space, contains numbers that aren't representable by floating point precision.
 * 2. The granularity within the viewport mapped to the clip space is too low - i.e. if the viewport maps to [0, 10],
 *    then we can only represent 11 distinct points.
 */
var needsNewClipSpace = function (viewport, toClipSpace) {
    var isOutOfBounds = isDateOutOfBounds(viewport.start, toClipSpace) || isDateOutOfBounds(viewport.end, toClipSpace);
    var distanceMS = viewport.end.getTime() - viewport.start.getTime();
    var distanceClipSpace = toClipSpace(viewport.end.getTime()) - toClipSpace(viewport.start.getTime());
    var hasTooLowGranularity = distanceMS > distanceClipSpace && distanceClipSpace < MIN_GRANULARITY;
    return isOutOfBounds || hasTooLowGranularity;
};
export { clipSpaceConversion as a, needsNewClipSpace as b, constructChartScene as c, getCSSColorByString as g, numDataPoints as n, vertices as v };
